// extracted by mini-css-extract-plugin
export default {"container":"uqv12SPr99Lhx2MynWJT","title":"ilcrsb5GXG3lFqz1jiq8","iconContainer":"bg2QIPZ1kihLGVUCqPS7","pulse":"xmjoqUVflmce6vPT3rVF"};